import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { Loading } from './components/ui';
import { Landing } from './public/Landing';
import { SignIn } from './public/SignIn';

const Apply = lazy(() => import('./public/Apply'));
const Portal = lazy(() => import('./portal/Portal'));
const Console = lazy(() => import('./console/Console'));

export function App() {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/portal/*" element={<Portal />} />
        <Route path="/console/*" element={<Console />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
